import { Project } from '@consigli/types';

import { CardGrid } from '@/layouts/card-grid';

import { constructionTypeImage } from './construction-type-image';
import { ProjectCard } from './project-card';

interface ProjectCardsProps {
  projects: Project[];
}

export const ProjectCards = (props: ProjectCardsProps) => {
  const { projects } = props;

  return (
    <CardGrid>
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          icon={constructionTypeImage(project.constructionTypes).src}
        />
      ))}
    </CardGrid>
  );
};
